import { GetOneConsultant } from '~/domain/usecases/consultant/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';

import {
  InvalidCredentialsError,
  NotFound,
  BadRequestError,
  UnexpectedError,
} from '~/domain/errors';

export class RemoteGetOneConsultant implements GetOneConsultant {
  private readonly url: string;

  private readonly httpCLient: HttpClient<GetOneConsultant.Model>;

  constructor(url: string, httpClient: HttpClient<GetOneConsultant.Model>) {
    this.url = url;
    this.httpCLient = httpClient;
  }

  getOne = async (
    params: GetOneConsultant.Params,
  ): Promise<GetOneConsultant.Model> => {
    const httpResponse = await this.httpCLient.request({
      url: `${this.url}/${params.id}`,
      method: 'get',
    });

    console.log('GetOneConsultant request: ', httpResponse);
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  };
}
